import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptHashtag } from "../adapters/adaptHashtags";

const fetchAdminHashtag = async (uuid: string) => {
	const response = await cmsClient.get<IAdminHashtag>(
		`/homepage/admin/hashtags/${uuid}/`
	);

	return response.data;
};

const useAdminHashtag = (uuid: string) => {
	const query = useQuery(
		["admin-hashtag", uuid],
		() => fetchAdminHashtag(uuid),
		{
			enabled: !!uuid,
			select: adaptHashtag
		}
	);

	return query;
};

export default useAdminHashtag;
